import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function IdCardIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.5 8.12941C15.2143 8.48235 14.7679 9.68235 14.6607 11.5882H16.3393C16.2143 9.7 15.7857 8.5 15.5 8.12941Z"
        fill="currentColor"
      />
      <path
        d="M13.3393 16.3176C13.0714 15.4529 12.9107 14.4294 12.8393 13.3529H11.1071C11.375 14.6235 12.2143 15.7 13.3214 16.3176H13.3393Z"
        fill="currentColor"
      />
      <path
        d="M13.3393 8.62353C12.2143 9.24118 11.3929 10.3 11.125 11.5882H12.8571C12.9107 10.5118 13.0714 9.50588 13.3571 8.62353H13.3393Z"
        fill="currentColor"
      />
      <path
        d="M16.3393 13.3529H14.6607C14.7857 15.2412 15.2143 16.4412 15.5 16.8118C15.7857 16.4588 16.2321 15.2588 16.3393 13.3529Z"
        fill="currentColor"
      />
      <path
        d="M19.875 13.3529H18.1429C18.0893 14.4294 17.9286 15.4353 17.6429 16.3176C18.7679 15.7 19.5893 14.6412 19.8571 13.3529H19.875Z"
        fill="currentColor"
      />
      <path
        d="M7.46429 31H23.5357C26 31 28 29.0235 28 26.5882V5.41176C28 2.97647 26 1 23.5357 1H7.46429C5 1 3 2.97647 3 5.41176V26.5882C3 29.0235 5 31 7.46429 31ZM19.0714 25.7059H11.9286C11.4286 25.7059 11.0357 25.3176 11.0357 24.8235C11.0357 24.3294 11.4286 23.9412 11.9286 23.9412H19.0714C19.5714 23.9412 19.9643 24.3294 19.9643 24.8235C19.9643 25.3176 19.5714 25.7059 19.0714 25.7059ZM15.5 6.29412C18.9464 6.29412 21.75 9.06471 21.75 12.4706C21.75 15.8765 18.9464 18.6471 15.5 18.6471C12.0536 18.6471 9.25 15.8765 9.25 12.4706C9.25 9.06471 12.0536 6.29412 15.5 6.29412ZM10.1429 20.4118H20.8571C21.3571 20.4118 21.75 20.8 21.75 21.2941C21.75 21.7882 21.3571 22.1765 20.8571 22.1765H10.1429C9.64286 22.1765 9.25 21.7882 9.25 21.2941C9.25 20.8 9.64286 20.4118 10.1429 20.4118Z"
        fill="currentColor"
      />
      <path
        d="M19.875 11.5882C19.6071 10.3176 18.7679 9.24118 17.6607 8.62353C17.9286 9.48824 18.0893 10.5118 18.1607 11.5882H19.8929H19.875Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
